import React from 'react';
import StockContext from '../../../contexts/StocksContext'
import './stockstemplates.css'

import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid

import { useState } from 'react';



export const StockPrices = () => {

  
  let {
    reversedStockPrices
  } = React.useContext(StockContext);

    
  // eslint-disable-next-line
      const [columnDefs, setColumnDefs] = useState([
        
        {
          headerName: 'Day',
          valueGetter: (p) => p.data.id,
          flex: 0.1,
        },

        {
          headerName: 'Date',
          valueGetter: (p) => p.data.timestamp,
          flex: 0.3,
        },
        /*
        {
          headerName: 'Open',
          valueGetter: (p) => p.data.open,
          flex: 0.2,
        },
      */
        {
          field: 'Last Traded Price',
          valueFormatter: (p) => p.data.close,
          flex: 0.3,
        
        },
        /*
        {
          field: 'High',
          valueGetter: (p) => p.data.high,
          flex: 0.2,
        },
        {
          field: 'Low',
          valueGetter: (p) => p.data.low,
          flex: 0.2,
        },
      */
         {
          field: 'Volume',
          valueGetter: (p) => p.data.volume,
          flex: 0.4,
        
        },
    
      
      ]);
  

  return (
 
    <div className="stockPricesDisplay" > 
      
        <div style={{ width: '100%', height: '100%' }} className="ag-theme-quartz">
          {Array.isArray(reversedStockPrices) && reversedStockPrices.map((stock, index) => (
           <React.Fragment key={index}>
            <label style={{margin:'10px', fontWeight:'500', fontSize: '22px'}}>{stock.symbol}</label>
            <AgGridReact 
              rowData={stock.prices} 
              columnDefs={columnDefs} 
              // Make entire grid read‑only
              defaultColDef={{
                editable: false
              }}

              // Prevent dragging/reordering columns
              suppressMovableColumns={true}
            />
            <br></br>
            </React.Fragment>                                    
          ))}
        </div>
     
    </div> 

  );
};
